import React from "react";
import {
  Scale,
  FileText,
  Clock,
  Search,
  Users,
  Shield,
  BookOpen,
  Gavel,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Case Management Systems",
    description:
      "Build comprehensive platforms for legal case tracking and management",
    icon: Gavel,
  },
  {
    title: "Contract Management",
    description: "Develop contract lifecycle management with e-signatures",
    icon: FileText,
  },
  {
    title: "Legal Research Tools",
    description: "AI-powered legal research and document analysis",
    icon: Search,
  },
  {
    title: "Client Portals",
    description: "Secure portals for client communication and document sharing",
    icon: Users,
  },
  {
    title: "Billing & Time Tracking",
    description: "Legal billing systems with time capture and invoicing",
    icon: Clock,
  },
  {
    title: "Document Automation",
    description: "Template-based document generation and assembly",
    icon: BookOpen,
  },
  {
    title: "Compliance Management",
    description: "Track regulatory compliance and deadlines",
    icon: Shield,
  },
  {
    title: "Practice Management",
    description: "End-to-end law firm management solutions",
    icon: Scale,
  },
];

const STATS = [
  { value: "500+", label: "Law Firms" },
  { value: "1M+", label: "Cases Managed" },
  { value: "50%", label: "Time Saved" },
  { value: "Secure", label: "& Compliant" },
];

const LegalIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="legal"
      industryTitle="Legal"
      industrySubtitle="Tech"
      heroDescription="Modernizing legal practices with innovative case management systems, contract automation, and legal research tools that improve efficiency and client service."
      themeColor="#1e40af"
      themeColorLight="#3b82f6"
      themeGradient="linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%)"
      HeroIcon={Scale}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1645570990200-2701a49d45ca?q=80&w=1242&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default LegalIndustryPage;
